import { useCallback, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutPageTitle, LayoutSubHeader } from '@/features/layout';
import { Tabs, TabsList, TabsTrigger } from '@/shared/ui/Tabs';
import { WorksheetList, TemplateList } from '@/features/template-manager';

type TemplatesTab = 'worksheets' | 'templates';

const pathToTab: Record<string, TemplatesTab> = {
  '/templates/worksheets': 'worksheets',
  '/templates/templates': 'templates',
};

export default function TemplatesPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname === '/templates' ||
      location.pathname === '/templates/'
    ) {
      navigate('/templates/worksheets', { replace: true });
    }
  }, [location.pathname, navigate]);

  const activeTab: TemplatesTab = pathToTab[location.pathname] || 'worksheets';

  const handleTabChange = useCallback(
    (value: string) => {
      navigate(`/templates/${value}`);
    },
    [navigate]
  );

  return (
    <>
      <LayoutPageTitle title="Templates" />
      <LayoutSubHeader>
        <Tabs value={activeTab} onValueChange={handleTabChange}>
          <TabsList>
            <TabsTrigger value="worksheets">Worksheets</TabsTrigger>
            <TabsTrigger value="templates">Templates</TabsTrigger>
          </TabsList>
        </Tabs>
      </LayoutSubHeader>
      {activeTab === 'worksheets' && <WorksheetList />}
      {activeTab === 'templates' && <TemplateList />}
    </>
  );
}
